import { Button, makeStyles } from '@material-ui/core';
import { useHistory } from 'react-router';

const useStyles = makeStyles((theme) => ({
  paper: (props) => ({
    marginTop: props.marginTop !== undefined ? theme.spacing(props.marginTop) : theme.spacing(-5.6),
    marginRight:
      props.marginRight !== undefined ? theme.spacing(props.marginRight) : theme.spacing(43),
    display: 'flex',
    justifyContent: 'flex-end',
  }),
}));

export default function BackButton(props) {
  const { handle, marginTop, marginRight, ...buttonProps } = props;
  const classes = useStyles({ marginTop, marginRight });
  const history = useHistory();

  const goBack = async () => {
    history.goBack();
  };

  return (
    <div className={classes.paper}>
      {handle ? (
        <Button variant="contained" color="primary" onClick={handle} {...buttonProps}>
          Back
        </Button>
      ) : (
        <Button variant="contained" color="primary" onClick={goBack} {...buttonProps}>
          Back
        </Button>
      )}
    </div>
  );
}
